namespace SP {
    export interface DashboardSettings {
        id: string;
        gridStackFloat: boolean;
        gridStackMargin: number;
        selectedCustomers: string[];
        colorTheme: string;
        borderRadius: number;
        boxShadow: boolean;
    }
}